import { createSlice } from '@reduxjs/toolkit'

export const couponSlice = createSlice({
  name: 'coupon',
  initialState: {
    title: 'Teknikforce store',
    files: [],
    code: 'SALE20',
    terms: 'This coupon is only valid for online purchases',
    description: '20% OFF on your next purchase',
    offer: '10% OFF',
    effectiveDate: new Date().toISOString().split('T')[0],
    fontFamily: 'Arial, sans-serif',
    cardColor: '#ffffff',
    titleColor: '#000000',
    descriptionColor: '#000000',
    termsColor: '#000000',
    expiryTextColor: '#000000',
    buttonColor: '#1e2746',
    buttonTextColor: '#ffffff',
    buttonText: 'Get coupon',
    offerBorderColor: '#000000',
    offerTextColor: '#000000'
  },
  reducers: {
    setCouponField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setLogoFile(state, action) {
      state.files[0] = action.payload
    },
    initializeCoupon(state, action) {
      state.title = 'Teknikforce store'
      state.files = []
      state.code = 'SALE20'
      state.terms = 'This coupon is only valid for online purchases'
      state.description = '20% OFF on your next purchase'
      state.offer = '10% OFF'
      state.effectiveDate = new Date().toISOString().split('T')[0]
      state.fontFamily = 'Arial, sans-serif'
      state.cardColor = '#ffffff'
      state.titleColor = '#000000'
      state.descriptionColor = '#000000'
      state.termsColor = '#000000'
      state.expiryTextColor = '#000000'
      state.buttonColor = '#1e2746'
      state.buttonTextColor = '#ffffff'
      state.buttonText = 'Get coupon'
      state.offerBorderColor = '#000000'
      state.offerTextColor = '#000000'
    }
  }
})

export const {
  setCouponField,
  setLogoFile,
  initializeCoupon
} = couponSlice.actions
export default couponSlice.reducer